import React, { Component } from 'react';
import { init } from './../casino/mygames.js';

class MyGames extends Component {
	componentWillMount() {
		init();
	}

	componentDidMount() {
		document.getElementsByClassName('content pusher')[0].scrollTop = 0;
	}

	render() {
		return (
			<div id="my-games" />
		);
	}
}

export default MyGames;



// WEBPACK FOOTER //
// ./mobile-core/src/components/my-games.js